import React, { useState, useEffect, useRef } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { ToggleSwitch } from "../../components/ToggleSwitch";
import { DynamicInput } from "../../components/DynamicInput";
import IntlCurrencyInput from "react-intl-currency-input"
import { StldInput } from '../../styled-components/StyledInput.style';
import { PartialSinistroTimeSheets } from '../PartialSinistroTimesheets';
import api from '../../services/api';
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { ContadorCaracteres } from '../ContadorCaracteres';


const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

export const ModalTimesheetFinalizar = (
    {
        isOpen,
        onAfterOpen,
        onRequestClose,
        timesheet,
        finalizarResumo,
        finalizarResumoAccess,
        disableButtons = false
    }) => {
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: "0px",
            transform: 'translate(-50%, -50%)',
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const [IsVistoriaReuniao, setIsVistoriaReuniao] = useState(false);
    const [QuantidadeVistoriaReuniao, setQuantidadeVistoriaReuniao] = useState(0);
    const [TimesheetParcial, setTimesheetParcial] = useState(false);

    const [VersaoRelatorioEntregue, setVersaoRelatorioEntregue] = useState(false);
    const [DescricaoVersaoRelatorio, setDescricaoVersaoRelatorio] = useState("");
    const [EmitirART, setEmitirART] = useState(false);
    const [RaderEntregue, setRaderEntregue] = useState(false);
    const [ParticularidadeSinistro, setParticularidadeSinistro] = useState("");
    const [Observacao, setObservacao] = useState("");
    const [ValorPleiteado, setValorPleiteado] = useState(0);
    const [ValorEstimativaPrejuizo, setValorEstimativaPrejuizo] = useState(0);
    const [PleiteadoObservacao, setPleiteadoObservacao] = useState("");
    const [ValorApurado, setValorApurado] = useState(0);
    const [ApurdadoObservacao, setApurdadoObservacao] = useState("");
    const [AnaliseVR, setAnaliseVR] = useState(false);
    const [AnaliseVRObsevacao, setAnaliseVRObsevacao] = useState("");

    const [numeroSinistro, setNumeroSinistro] = useState("");
    const [numeroApolice, setNumeroApolice] = useState("");
    const [numeroAviso, setNumeroAviso] = useState("");
    const [numeroProcesso, setNumeroProcesso] = useState("");
    const [numeroISJ, setNumeroISJ] = useState("");
    const [analista, setAnalista] = useState("");

    const advanceTimesheet = { name: 'advanceTimesheet', label: 'Vistoria e Reuniões', status: finalizarResumo?.isVistoriaReuniao || finalizarResumo?.qtdTotalVR > 0 ? true : false };
    const analiseVR = { name: 'analiseVR', label: 'Análise de VR', status: finalizarResumo?.analiseVR };
    const parcial = { name: 'parcial', label: 'TimeSheet Parcial', status: finalizarResumo?.timesheetParcial };
    const relatorioAnalista = { name: 'relatorioAnalista', label: 'Relatório já enviado p/ Analista?', status: finalizarResumo?.versaoRelatorioEntregue };
    const financeiro = { name: 'financeiro', label: 'Foi entregue Rader para Adm./Financeiro?', status: finalizarResumo?.raderEntregue };
    const emissaoART = { name: 'emissaoART', label: 'Vai emitir ART?', status: finalizarResumo?.emitirART };
    const accessNivel = finalizarResumoAccess?.nivel ?? 3;

    const history = useHistory();

    const getResumo = async () => {
        try {
            setIsVistoriaReuniao(finalizarResumo?.isVistoriaReuniao || finalizarResumo?.qtdTotalVR > 0 ? true : false);
            setTimesheetParcial(finalizarResumo?.timesheetParcial || false);
            setVersaoRelatorioEntregue(finalizarResumo?.versaoRelatorioEntregue || false);
            setEmitirART(finalizarResumo?.emitirART || false);
            setRaderEntregue(finalizarResumo?.raderEntregue || false);
            setAnaliseVR(finalizarResumo?.analiseVR || false);
            setQuantidadeVistoriaReuniao(finalizarResumo?.quantidadeVistoriaReuniao || finalizarResumo?.qtdTotalVR > 0 ? finalizarResumo?.qtdTotalVR : 0);
            setDescricaoVersaoRelatorio(finalizarResumo?.descricaoVersaoRelatorio);
            setParticularidadeSinistro(finalizarResumo?.particularidadeSinistro);
            setObservacao(finalizarResumo?.observacao);
            setValorPleiteado(finalizarResumo?.valorPleiteado);
            setValorEstimativaPrejuizo(finalizarResumo?.valorEstimativaPrejuizo);
            setPleiteadoObservacao(finalizarResumo?.pleiteadoObservacao);
            setValorApurado(finalizarResumo?.valorApurado);
            setApurdadoObservacao(finalizarResumo?.apurdadoObservacao);
            setNumeroSinistro(timesheet?.sinistro?.numeroSinistro);
            setNumeroApolice(timesheet?.sinistro?.numeroApolice);
            setNumeroAviso(timesheet?.sinistro?.numeroAviso);
            setNumeroProcesso(timesheet?.sinistro?.numeroProcessoJudicial);
            setNumeroISJ(timesheet?.sinistro?.numeroISJ);
            setAnalista(timesheet?.sinistro?.analista);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if(isOpen)
            getResumo()
    }, [isOpen]);

    const submitForm = async (finalizar) => {

        var payload = {
            idSinistro: timesheet.sinistro.idSinistro,
            finalizar,
            IsVistoriaReuniao,
            QuantidadeVistoriaReuniao: parseInt(QuantidadeVistoriaReuniao),
            TimesheetParcial,
            VersaoRelatorioEntregue,
            DescricaoVersaoRelatorio,
            EmitirART,
            RaderEntregue,
            ParticularidadeSinistro,
            Observacao,
            ValorPleiteado,
            ValorEstimativaPrejuizo,
            PleiteadoObservacao,
            ValorApurado,
            ApurdadoObservacao,
            AnaliseVR,
            AnaliseVRObsevacao,
            numeroSinistro,
            numeroApolice,
            numeroAviso,
            numeroProcesso,
            numeroISJ,
            analista
        }

        if (finalizar) {
            if(!numeroSinistro || !numeroApolice || !numeroAviso || !numeroProcesso || !numeroISJ || !analista) {
                Swal.fire({
                    text: "Um dos dados(Analista, Nº do Sinistro, Nº da Apólice, Nº do Aviso, Nº do Processo, Nº ISJ) não foi informado. Deseja prosseguir com a finalização?",
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        Swal.fire({
                            title: 'Aguarde...',
                            html: 'Enviando dados para o servidor.',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            showConfirmButton: false,
                            willOpen: () => {
                                Swal.showLoading()
                            },
                        });
        
                        await api.put(`Timesheet/${timesheet.timesheet.idTimesheet}/finalizar`, payload)
                        .then(async (response) => {
            
                            let text = "Salvo com sucesso!";
                            if (finalizar) {
                                text = "Enviado para aprovação com sucesso!";
                            }
            
                            Swal.close();
                            Swal.fire({
                                title: "Sucesso",
                                text: text,
                                icon: "success",
                                showConfirmButton: false,
                                timer: 2500
                            });
            
                            // verificar o nivel do usuário se sim pode ir para a tela de timesheet
                            (finalizar && accessNivel < 3) ? history.push('/timesheet') : window.location.reload(false);
                        })
                        .catch((error) => {
                            Swal.fire({
                                title: "Erro",
                                text: "Verifique as informações e tente novamente.",
                                icon: "error",
                                showConfirmButton: false,
                                timer: 2000
                            });
                        });
                    }
                  });
            }
            else {
                Swal.fire({
                    title: 'Aguarde...',
                    html: 'Enviando dados para o servidor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading()
                    },
                });

                await api.put(`Timesheet/${timesheet.timesheet.idTimesheet}/finalizar`, payload)
                .then(async (response) => {
    
                    let text = "Salvo com sucesso!";
                    if (finalizar) {
                        text = "Enviado para aprovação com sucesso!";
                    }
    
                    Swal.close();
                    Swal.fire({
                        title: "Sucesso",
                        text: text,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2500
                    });
    
                    // verificar o nivel do usuário se sim pode ir para a tela de timesheet
                    (finalizar && accessNivel < 3) ? history.push('/timesheet') : window.location.reload(false);
                })
                .catch((error) => {
                    Swal.fire({
                        title: "Erro",
                        text: "Verifique as informações e tente novamente.",
                        icon: "error",
                        showConfirmButton: false,
                        timer: 2000
                    });
                });
            }
        }
        else {
            Swal.fire({
                title: 'Aguarde...',
                html: 'Enviando dados para o servidor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });

            await api.put(`Timesheet/${timesheet.timesheet.idTimesheet}/finalizar`, payload)
            .then(async (response) => {

                let text = "Salvo com sucesso!";
                if (finalizar) {
                    text = "Enviado para aprovação com sucesso!";
                }

                Swal.close();
                Swal.fire({
                    title: "Sucesso",
                    text: text,
                    icon: "success",
                    showConfirmButton: false,
                    timer: 2500
                });

                // verificar o nivel do usuário se sim pode ir para a tela de timesheet
                (finalizar && accessNivel < 3) ? history.push('/timesheet') : window.location.reload(false);
            })
            .catch((error) => {
                Swal.fire({
                    title: "Erro",
                    text: "Verifique as informações e tente novamente.",
                    icon: "error",
                    showConfirmButton: false,
                    timer: 2000
                });
            });
        }
    };






    const formatNumberValue = (value) => {

        if (null === value || undefined === value || '' === value) {
            return 0;
        }


        if (typeof value === 'number') {
            return value;
        }

        value = value.replace(/(\.)/g, '').replace('R$', '').replace(',', '.');
        if (isNaN(value)) {
            return 0;
        }

        value = parseFloat(value);

        return value;
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex className="modalFinalizarTimesheet">
                <StyledForm style={{ width: "100%" }} >
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group" style={{ margin: "17px 0px 0 9px" }}>
                                <p className="modal-title">Dados para análise do TimeSheet</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <StyledTablePage>
                        <Flex.Item className="flex-column-12">
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <ToggleSwitch config={advanceTimesheet} setStatus={(status) => setIsVistoriaReuniao(status)} />
                                </div>

                                {IsVistoriaReuniao ? <> <div className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"number"}
                                        placeholder={"Digite aqui"}
                                        label={"Quantidade"}
                                        name={"Quantidade"}
                                        value={QuantidadeVistoriaReuniao}
                                        paramMethod={(value) => setQuantidadeVistoriaReuniao(value)}
                                        disabled={disableButtons}
                                    />
                                </div>
                                </> : null}
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Local"}
                                        label={"Local"}
                                        name={"Local"}
                                        componentReadOnly={true}
                                        disabled={true}
                                        value={timesheet?.sinistro?.local}
                                    />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container">

                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <StldInput>
                                        <label className="focused">Pleiteado</label>
                                        <IntlCurrencyInput
                                            currency="BRL"
                                            config={currencyConfig}
                                            defaultValue={ValorPleiteado}
                                            onChange={(_event, value, _maskedValue) => setValorPleiteado(value)}
                                            disabled={disableButtons} />
                                    </StldInput>
                                </div>
                                <div style={{ width: "calc(100% - 275px)" }} className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite aqui"}
                                        label={"Observação do Pleiteado"}
                                        name={"Observação do Pleiteado"}
                                        value={PleiteadoObservacao}
                                        paramMethod={(value) => setPleiteadoObservacao(value)}
                                        disabled={disableButtons}
                                    />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <StldInput>
                                        <label className="focused">Apurado</label>
                                        <IntlCurrencyInput
                                            currency="BRL"
                                            config={currencyConfig}
                                            defaultValue={ValorApurado}
                                            onChange={(_event, value, _maskedValue) => setValorApurado(value)}
                                            disabled={disableButtons} />
                                    </StldInput>
                                </div>
                                <div style={{ width: "calc(100% - 275px)" }} className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite aqui"}
                                        label={"Observação do Apurado"}
                                        name={"Observação do Apurado"}
                                        value={ApurdadoObservacao}
                                        paramMethod={(value) => setApurdadoObservacao(value)}
                                        disabled={disableButtons}
                                    />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container flex">
                                <div style={{ marginRight: "43px" }} className="form-container-min flex-column justify-content-center legend-info">
                                    <ToggleSwitch
                                        config={analiseVR}
                                        setStatus={(status) => setAnaliseVR(status)}
                                        disabled={disableButtons} />
                                </div>
                                <div
                                    style={{ width: "calc(100% - 275px)" }}
                                    className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite aqui"}
                                        label={"Observação da Análise de VR"}
                                        name={"Observação da Análise de VR"}
                                        paramMethod={(value) => setAnaliseVRObsevacao(value)}
                                        value={AnaliseVRObsevacao}
                                        disabled={disableButtons}
                                    />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container d-flex">
                                <div className="form-container-min flex-column justify-content-center legend-info  flex-fill ">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Nº do Sinistro"}
                                        label={"Nº do Sinistro"}
                                        name={"Nº do Sinistro"}
                                        paramMethod={(value) => setNumeroSinistro(value)}
                                        value={numeroSinistro}
                                        disabled={disableButtons}
                                    />
                                </div>
                                <div className="form-container-min flex-column justify-content-center legend-info  flex-fill ">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Nº da Apólice"}
                                        label={"Nº da Apólice"}
                                        name={"Nº da Apólice"}
                                        paramMethod={(value) => setNumeroApolice(value)}
                                        value={numeroApolice}
                                        disabled={disableButtons}
                                    />
                                </div>
                                <div className="form-container-min flex-column justify-content-center legend-info  flex-fill ">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Nº do Aviso"}
                                        label={"Nº do Aviso"}
                                        name={"Nº do Aviso"}
                                        paramMethod={(value) => setNumeroAviso(value)}
                                        value={numeroAviso}
                                        disabled={disableButtons}
                                    />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info  flex-fill ">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Nº do Processo"}
                                        label={"Nº do Processo"}
                                        name={"Nº do Processo"}
                                        paramMethod={(value) => setNumeroProcesso(value)}
                                        value={numeroProcesso}
                                        disabled={disableButtons}
                                    />
                                </div>
                                <div className="form-container-min flex-column justify-content-center legend-info  flex-fill ">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Nº ISJ"}
                                        label={"Nº ISJ"}
                                        name={"Nº ISJ"}
                                        paramMethod={(value) => setNumeroISJ(value)}
                                        value={numeroISJ}
                                        disabled={disableButtons}
                                    />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <StldInput>
                                        <label className="focused">Valor deste TimeSheet</label>
                                        <IntlCurrencyInput
                                            currency="BRL"
                                            config={currencyConfig}
                                            defaultValue={formatNumberValue(timesheet?.timesheet?.totalValor)}
                                            disabled={true} />
                                    </StldInput>
                                </div>
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <StldInput>
                                        <label className="focused">Estimativa de Prejuízo</label>
                                        <IntlCurrencyInput
                                            currency="BRL"
                                            config={currencyConfig}
                                            defaultValue={ValorEstimativaPrejuizo}
                                            onChange={(_event, value, _maskedValue) => setValorEstimativaPrejuizo(value)}
                                            disabled={disableButtons} />
                                    </StldInput>
                                </div>
                            </div>
                            <div className="form-wrapper filter-container">
                                <div className="flex-column justify-content-center legend-info mt-3" style={{ width: '100%', marginLeft: "14px" }}>
                                    <StldInput>
                                        <label className="focused focused_index">Particularidades do Sinistro</label>
                                        <textarea
                                            rows="3"
                                            className="input-form-list"
                                            style={{ width: '100%' }}
                                            name="Particularidades do Sinistro"
                                            placeholder="Digite aqui"
                                            defaultValue={ParticularidadeSinistro}
                                            onChange={(event) => setParticularidadeSinistro(event.target.value)}
                                            disabled={disableButtons}
                                            maxLength={500}
                                        />
                                        <Flex.Item className="pull-right"> <ContadorCaracteres textoInicial={ParticularidadeSinistro} limite={500} ></ContadorCaracteres></Flex.Item>
                                    </StldInput>
                                </div>
                            </div>
                        </Flex.Item>
                    </StyledTablePage>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group" style={{ margin: "17px 0px 0 9px" }}>
                                <p className="modal-title">Dados para Administrativo</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <StyledTablePage>
                        <Flex.Item className="flex-column-12">
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={""}
                                        label={"Seguradora"}
                                        name={"Seguradora"}
                                        componentReadOnly={true}
                                        disabled={true}
                                        value={timesheet?.cliente?.clienteNome}
                                    />
                                </div>
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                    required="required"
                                        type={"text"}
                                        placeholder={""}
                                        label={"* Analista"}
                                        name={"Analista"}
                                        disabled={disableButtons}
                                        value={analista}
                                        paramMethod={(value) => setAnalista(value)}
                                    />
                                </div>
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <ToggleSwitch
                                        config={financeiro}
                                        setStatus={(status) => setRaderEntregue(status)}
                                        disabled={disableButtons} />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <ToggleSwitch
                                        config={relatorioAnalista}
                                        setStatus={(status) => setVersaoRelatorioEntregue(status)}
                                        disabled={disableButtons} />
                                </div>
                                <div style={{ width: "calc(100% - 375px)" }} className="form-container-min flex-column justify-content-center legend-info">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite aqui"}
                                        label={"Observação envio do relatório"}
                                        name={"Observação envio do relatório"}
                                        value={DescricaoVersaoRelatorio}
                                        paramMethod={(value) => setDescricaoVersaoRelatorio(value)}
                                        disabled={disableButtons}
                                        maxLength={250}
                                    />

                                </div>
                            </div>
                            <div className="form-wrapper filter-container">
                                <div className="form-container-min flex-column justify-content-center legend-info">
                                    <ToggleSwitch
                                        config={emissaoART}
                                        setStatus={(status) => setEmitirART(status)}
                                        disabled={disableButtons} />
                                </div>
                            </div>
                            <div className="form-wrapper filter-container my-2 mt-3">
                                <div className="flex-column justify-content-center legend-info" style={{ width: '100%', marginLeft: "14px" }}>
                                    <StldInput>
                                        <label className="focused focused_index">Observação</label>
                                        <textarea
                                            rows="3"
                                            className="input-form-list"
                                            style={{ width: '100%' }}
                                            name="Observação"
                                            placeholder="Digite aqui"
                                            defaultValue={Observacao}
                                            onChange={(event) => setObservacao(event.target.value)}
                                            disabled={disableButtons}
                                        />
                                        <Flex.Item className="pull-right"> <ContadorCaracteres textoInicial={Observacao} limite={250} ></ContadorCaracteres></Flex.Item>
                                    </StldInput>
                                </div>
                            </div>
                            <div className="form-wrapper filter-container mt-3">
                                <div className="flex-column justify-content-center legend-info outros-ts">
                                    <PartialSinistroTimeSheets
                                        idTimesheet={timesheet?.timesheet?.idTimesheet}
                                        isFromProjetoInterno={true}
                                    ></PartialSinistroTimeSheets>
                                </div>
                            </div>
                        </Flex.Item>
                        <Flex.Item>

                        </Flex.Item>
                    </StyledTablePage>

                    {
                        !disableButtons &&
                        <Flex>
                            <Flex.Item className="modal-width">
                                <div className="position-relative form-group modal-align-center">
                                    {
                                        finalizarResumoAccess?.isEdit && <input style={{ marginRight: "50px" }} className='default-button-red' value='Salvar' type="button" onClick={() => submitForm(false)} />
                                    }
                                    {
                                        finalizarResumoAccess?.finalizar && <input className='default-button-red' value='Finalizar' type="button" onClick={() => submitForm(true)} />
                                    }
                                </div>
                            </Flex.Item>
                        </Flex>
                    }
                </StyledForm>
            </Flex>
        </Modal>
    );
};